import React from 'react'
import {
  Svg,
  RadioLabel,
  CheckboxLabel,
  OwerCheckboxLabel,
  OwerCopiesCheckboxLabel,
  Image
} from '../components'
import {
  userImageUrls
} from '../constants'

const createUserRadioLabel = ({ object, handleChange, selectedObject }) => {
  let imageUrl = object.imageURL
  if (!imageUrl) {
    imageUrl = userImageUrls[object.imageId]
  }
  return <RadioLabel
    key={object.id}
    object={object}
    value={object.id}
    checked={selectedObject ? selectedObject.id === String(object.id) : null}
    changed={handleChange}>
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      <Image style={{ paddingRight: '12px' }} imageUrl={imageUrl} defaultImage='user'/>
      {object.displayName}
    </div>
  </RadioLabel>
}

const createEditableOwerCopiesCheckbokLabel = ({ exponent, fixedAmount, object, handleChange, selectedObjects, handleInputChanged, amount, valid }) => {
  return <OwerCopiesCheckboxLabel
    exponent={exponent}
    fixedAmount={fixedAmount}
    hideCheckbox={!object.coverCost}
    amount={amount}
    valid={valid}
    key={object.id}
    object={object}
    inputChanged={handleInputChanged}
    changed={handleChange}
    value={object.id}
    checked={selectedObjects.map(el => el.user.id).includes(object.id)} >
  </OwerCopiesCheckboxLabel>
}

const createEditableOwerCheckbokLabel = ({ prefix, exponent, fixedAmount, object, handleChange, selectedObjects, handleInputChanged, amount, valid, isForeign, displayRate, displayExponent, displayCode, bookSymbol, bookExponent }) => {
  return <OwerCheckboxLabel
    exponent={exponent}
    fixedAmount={fixedAmount}
    hideCheckbox={!object.coverCost}
    amount={amount}
    valid={valid}
    key={prefix ? `${prefix}-${object.id}` : object.id}
    object={object}
    inputChanged={handleInputChanged}
    changed={handleChange}
    value={object.id}
    checked={selectedObjects.map(el => el.id).includes(object.id)}
    isForeign={isForeign}
    displayRate={displayRate}
    displayExponent={displayExponent}
    displayCode={displayCode}
    bookSymbol={bookSymbol}
    bookExponent={bookExponent} >
  </OwerCheckboxLabel>
}

const createOwerCheckbokLabel = ({ object, handleChange, selectedObjects, handleAddCoverCostUser }) => {
  let imageUrl = object.imageURL
  if (!imageUrl) {
    imageUrl = userImageUrls[object.imageId]
  }
  return <OwerCheckboxLabel
    handleAddCoverCostUser={handleAddCoverCostUser}
    hideCheckbox={!object.coverCost}
    key={object.id}
    object={object}
    changed={handleChange}
    value={object.id}
    checked={selectedObjects.map(el => el.id).includes(object.id)} >
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      <Image style={{ paddingRight: '12px' }} imageUrl={imageUrl} defaultImage='user'/>
      {object.displayName}
    </div>
  </OwerCheckboxLabel>
}

const createFilterUserCheckbokLabel = ({ object, handleChange, selectedObjects }) => {
  let imageUrl = object.imageURL
  if (!imageUrl) {
    imageUrl = userImageUrls[object.imageId]
  }

  return <CheckboxLabel
    disabled={false}
    key={object.id}
    object={object}
    changed={handleChange}
    value={object.id}
    checked={selectedObjects.map(el => el.id).includes(object.id)} >
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <Image style={{ paddingRight: '12px' }} imageUrl={imageUrl} size='56px' defaultImage='user'/>
        {object.displayName}
      </div>
    </div>
  </CheckboxLabel>
}

const createUserCheckbokLabel = ({ handleEdit, handleTrash }) => ({ object, handleChange, selectedObjects }) => {
  let imageUrl = object.imageURL
  if (!imageUrl) {
    imageUrl = userImageUrls[object.imageId]
  }

  let restrictedCoverCost = object.restrictedCoverCost
  if (object.restrictedCoverCost === true && object.coverCost === false) {
    restrictedCoverCost = false
  }

  return <CheckboxLabel
    disabled={restrictedCoverCost}
    key={object.id}
    object={object}
    changed={handleChange}
    value={object.id}
    checked={selectedObjects.map(el => el.id).includes(object.id)} >
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <Image style={{ paddingRight: '12px' }} imageUrl={imageUrl} size='56px' defaultImage='user'/>
        {object.displayName}
      </div>
      <div>
        {
          object.fromLine ? null :
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <div style={{ marginRight: '20px' }} onClick={(e) => handleEdit(e, object)}>
                <Svg icon='edit' size='24' className='gray700'/>
              </div>
              {
                object.restrictedDestroy || !handleTrash ?
                  null
                :
                 <div style={{ marginRight: '20px' }} onClick={(e) => handleTrash(e, object)}>
                   <Svg icon='delete' size='24' className='gray700'/>
                 </div>
              }
            </div>
        }
      </div>
    </div>
  </CheckboxLabel>
}

const createFreeUserCheckbokLabel = ({ handleEdit, handleTrash }) => ({ object, handleChange, selectedObjects }) => {
  let imageUrl = object.imageURL
  if (!imageUrl) {
    imageUrl = userImageUrls[object.imageId]
  }

  return <CheckboxLabel
    key={object.id}
    object={object}
    changed={handleChange}
    value={object.id}
    checked={selectedObjects.map(el => el.id).includes(object.id)} >
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <Image style={{ paddingRight: '12px' }} imageUrl={imageUrl} size='56px' defaultImage='user'/>
        {object.displayName}
      </div>
      <div>
        {
          object.fromLine ? null :
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <div style={{ marginRight: '20px' }} onClick={(e) => handleEdit(e, object)}>
                <Svg icon='edit' size='24' className='gray700'/>
              </div>
              {
                object.restrictedDestroy || !handleTrash ?
                  null
                :
                 <div style={{ marginRight: '20px' }} onClick={(e) => handleTrash(e, object)}>
                   <Svg icon='delete' size='24' className='gray700'/>
                 </div>
              }
            </div>
        }
      </div>
    </div>
  </CheckboxLabel>
}

export {
  createUserRadioLabel,
  createUserCheckbokLabel,
  createOwerCheckbokLabel,
  createFreeUserCheckbokLabel,
  createEditableOwerCheckbokLabel,
  createEditableOwerCopiesCheckbokLabel,
  createFilterUserCheckbokLabel
}
